import { IWorkingHoursSlot } from "../validation/workingHoursValidation";

export const timeToMinutes = (timeString: string): number => {
  const [hours, minutes] = timeString.split(":").map(Number);
  return hours * 60 + minutes;
};

export const minutesToTime = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, "0")}:${mins
    .toString()
    .padStart(2, "0")}`;
};

export const doTimeSlotsOverlap = (
  slot1: IWorkingHoursSlot,
  slot2: IWorkingHoursSlot
): boolean => {
  const start1 = timeToMinutes(slot1.startTime);
  const end1 = timeToMinutes(slot1.endTime);
  const start2 = timeToMinutes(slot2.startTime);
  const end2 = timeToMinutes(slot2.endTime);

  // Check if slots overlap
  return start1 < end2 && start2 < end1;
};

export const findOverlappingSlots = (
  slots: IWorkingHoursSlot[]
): { index1: number; index2: number }[] => {
  const overlaps: { index1: number; index2: number }[] = [];

  for (let i = 0; i < slots.length; i++) {
    for (let j = i + 1; j < slots.length; j++) {
      if (doTimeSlotsOverlap(slots[i], slots[j])) {
        overlaps.push({ index1: i, index2: j });
      }
    }
  }

  return overlaps;
};

export const validateDaySlots = (
  slots: IWorkingHoursSlot[],
  dayName: string
): string | null => {
  if (slots.length === 0) return null;

  // Check individual slot validity
  for (let i = 0; i < slots.length; i++) {
    const slot = slots[i];
    if (timeToMinutes(slot.startTime) >= timeToMinutes(slot.endTime)) {
      return `${dayName}: Крайният час трябва да е след началния час за период ${
        i + 1
      }`;
    }
  }

  // Check for overlaps
  const overlaps = findOverlappingSlots(slots);
  if (overlaps.length > 0) {
    const { index1, index2 } = overlaps[0];
    return `${dayName}: Периодите ${index1 + 1} (${slots[index1].startTime}-${
      slots[index1].endTime
    }) и ${index2 + 1} (${slots[index2].startTime}-${
      slots[index2].endTime
    }) се припокриват`;
  }

  return null;
};
